export const gathering = {
  aboutThisEvent: "About This Event",
  gatheringPlatforms: {
    gatheround: "Gatheround",
    zoom: "Zoom",
  },
  gatheringTypes: {
    virtual: "Virtual Event",
  },
  hostedBy: "Hosted By:<br/>{{host}}",
  howToJoin: {
    heading: "How to Join",
    description:
      "The {{platform}} link will be available here at the time of the event. We’ll also send you a link before via email!",
  },
  joinPlatform: "Join via {{platform}}",
  joinEventCta: "Join Event",
  materials: "Event materials",
  materialsUpsell: {
    plus: {
      description:
        "Get access to event materials when you become a premium member!",
      cta: "Upgrade for access",
    },
    visitor: {
      description:
        "Get access to event materials when you become a premium member!",
      cta: "Get Started",
    },
  },
  meeting: {
    cta: "Join Event",
    text: "Join via {{platform}}",
  },
  pageTitle: "Conceive Events",
  rsvpCta: "Sign Up",
  title: "Conceive Events",
  type: {
    docx: "Word Document",
    link: "Link",
    pdf: "PDF",
  },
};
